import { Flags } from 'constants/flags';
import { useProfile } from 'context/profile';

import { selectablePreferredProviderTypes } from './helpers';

// The picking group to send as preferredForGroupId, for the provider type being picked (its apiName).
// Undefined unless that type can have preferred providers, so pickers for the client's own types don't
// ask. The release flag is only checked here; the API checks the product.
export default function usePreferredForGroupId(groupId?: string | null, providerType?: string) {
  const { profile } = useProfile();
  const selectable = selectablePreferredProviderTypes(profile).some((type) => type.apiName === providerType);

  return groupId && selectable && profile.hasFlag(Flags.PreferredProviders) ? groupId : undefined;
}
